<template>
    <div v-if="!toggleStyle" v-bind="rootAttrs()" class="input-container">
        <div class="hint-container">
            <p class="input-hint"> {{ hint }} </p>
            <span class="tooltip-container" v-if="tooltipText" v-tooltip.left="tooltipText">
              <inline-svg
                  class="icon-info"
                  :src="require('@/assets/icons/info.svg')"></inline-svg>
            </span>
        </div>
        <div class="input-field-container">

            <div v-if="attachedFilePreview && Array.isArray(attachedFilePreview)">
                <div class="image-preview-container">
                    <!-- Show the first image as the preview -->
                    <img
                        class="image-attach-preview"
                        :src="attachedFilePreview[0]"
                        alt="Preview"
                    />
                    <!-- Overlay with the count of images -->
                    <div class="image-count-overlay">
                        +{{ attachedFilePreview.length }}
                    </div>
                </div>
            </div>

            <!-- Show single preview if only one file is selected -->
          <img
              class="image-attach-preview"
              v-if="attachedFilePreview"
              :src="attachedFilePreview"
              alt="Preview"
          />

            <!-- Non-image files (e.g. videos) cannot be previewed: show a file chip instead -->
            <div class="file-attach-preview" v-if="attachedFileName && !attachedFilePreview">
                <inline-svg :src="require(`@/assets/icons/${attachedFileIcon}`)"></inline-svg>
            </div>

            <inline-svg
                v-if="showLeadingIcon"
                class="leading-icon"
                :src="require(`@/assets/icons/${leadingIcon}`)"></inline-svg>
            <input
                v-bind="inputAttrs()"
                ref="customInput"
                :class="{ 'error': error, 'has-leading-icon': showLeadingIcon }"
                :type="effectiveType"
                :inputmode="effectiveInputMode"
                :step="step"
                :placeholder="inputPlaceholder"
                :value="customValue"
                :disabled="disabled"
                @click="$emit('click', $event)"
                @keyup="$emit('keyup', $event)"
                @input="onInput"/>
            <inline-svg
                v-if="hideContent"
                class="trailing-icon"
                @click="contentVisible = !contentVisible"
                :src="require(`@/assets/icons/${contentVisible ? 'eye-off.svg' : 'eye.svg'}`)">

            </inline-svg>
            <inline-svg
                v-if="fileAttachEnabled"
                class="trailing-icon"
                @click="onAttachFileClicked"
                :src="require('@/assets/icons/paperclip.svg')">

            </inline-svg>

            <input
                type="file"
                style="display: none"
                ref="fileInput"
                :accept="fileAccept"
                :multiple="multiple"
                @change="onFilePicked"/>

        </div>
    </div>
    <div
        v-if="toggleStyle && type === 'number'"
        v-bind="rootAttrs()"
        class="switch-row"
        :class="{disabled}"
    >
      <div class="text-content">
        <p v-if="hint" class="title">{{ hint }}</p>
        <p
            v-if="tooltipText"
            class="description"
            v-tooltip.top="tooltipText"
        >
          {{ tooltipText }}
        </p>
      </div>

      <div v-if="stepper && !isPhone()" class="stepper-group">
        <button
            type="button"
            class="stepper-btn"
            :disabled="disabled"
            @click="stepBy(-1)"
        >
          <inline-svg :src="require('@/assets/icons/minus.svg')" />
        </button>
        <input
            v-bind="inputAttrs()"
            class="number-input"
            min="0"
            :type="effectiveType"
            :inputmode="effectiveInputMode"
            :placeholder="placeholder"
            :disabled="disabled"
            :value="customValue"
            @click="$emit('click', $event)"
            @keyup="$emit('keyup', $event)"
            @input="onInput"
        >
        <button
            type="button"
            class="stepper-btn"
            :disabled="disabled"
            @click="stepBy(1)"
        >
          <inline-svg :src="require('@/assets/icons/plus.svg')" />
        </button>
      </div>
      <input
          v-else
          v-bind="inputAttrs()"
          class="number-input"
          min="0"
          :type="effectiveType"
          :inputmode="effectiveInputMode"
          :placeholder="placeholder"
          :disabled="disabled"
          :value="customValue"
          @click="$emit('click', $event)"
          @keyup="$emit('keyup', $event)"
          @input="onInput"
      >
    </div>
    <div
        v-if="toggleStyle && type !== 'number'"
        v-bind="rootAttrs()"
        class="switch-row switch-input"
        :class="{disabled}"
    >
    <div class="text-content">
      <p v-if="hint" class="title">{{ hint }}</p>
      <span class="tooltip-container" v-if="tooltipText" v-tooltip.left="tooltipText">
        <inline-svg
            class="icon-info"
            :src="require('@/assets/icons/info.svg')"></inline-svg>
      </span>
    </div>
    <div class="input-field-container">
      <div v-if="attachedFilePreview && Array.isArray(attachedFilePreview)">
        <div class="image-preview-container">
          <!-- Show the first image as the preview -->
          <img
              class="image-attach-preview"
              :src="attachedFilePreview[0]"
              alt="Preview"
          />
          <!-- Overlay with the count of images -->
          <div class="image-count-overlay">
            +{{ attachedFilePreview.length }}
          </div>
        </div>
      </div>
      <!-- Show single preview if only one file is selected -->
      <img
          class="image-attach-preview"
          v-if="attachedFilePreview"
          :src="attachedFilePreview"
          alt="Preview"
      />
      <!-- Non-image files (e.g. videos) cannot be previewed: show a file chip instead -->
      <div class="file-attach-preview" v-if="attachedFileName && !attachedFilePreview">
        <inline-svg :src="require(`@/assets/icons/${attachedFileIcon}`)"></inline-svg>
      </div>
      <inline-svg
          v-if="showLeadingIcon"
          class="leading-icon"
          :src="require(`@/assets/icons/${leadingIcon}`)"></inline-svg>
      <input
          v-bind="inputAttrs()"
          ref="customInput"
          :class="{ 'error': error, 'has-leading-icon': showLeadingIcon }"
          :type="effectiveType"
          :inputmode="effectiveInputMode"
          :step="step"
          :placeholder="inputPlaceholder"
          :value="customValue"
          :disabled="disabled"
          @click="$emit('click', $event)"
          @keyup="$emit('keyup', $event)"
          @input="onInput"/>
      <inline-svg
          v-if="hideContent"
          class="trailing-icon"
          @click="contentVisible = !contentVisible"
          :src="require(`@/assets/icons/${contentVisible ? 'eye-off.svg' : 'eye.svg'}`)">

      </inline-svg>
      <inline-svg
          v-if="fileAttachEnabled"
          class="trailing-icon"
          @click="onAttachFileClicked"
          :src="require('@/assets/icons/paperclip.svg')">

      </inline-svg>
      <input
          type="file"
          style="display: none"
          ref="fileInput"
          :accept="fileAccept"
          :multiple="multiple"
          @change="onFilePicked"/>
    </div>
  </div>

</template>

<script>
import Tooltip from 'primevue/tooltip';
import { toast } from "vue3-toastify";
import { applyDecimalInput, applyIntegerInput } from "@/helpers/numericInput";

export default {
    name: "DesignInput",
    inheritAttrs: false,
    directives: {
        'tooltip': Tooltip
    },
    emits: [
        'click',
        'keyup',
        'update:customValue',
        'update:attachedFile'
    ],
    props: {
        'type': {
            type: String,
            default: ""
        },
        'placeholder': {
            type: String,
          default: "",
          required: false
        },
        'min': {
            type: Number,
            default: 1
        },
        'onlyPng': {
          type: Boolean,
          default: false
        },
        'accept': {
          type: String,
          default: ""
        },
        'max': {
            type: Number,
            default: 100
        },
        'hint': {
            type: String,
            default: ""
        },
        'customValue': {
            type: [String, Number],
            default: ""
        },
        'error': {
            type: Boolean,
            default: false
        },
        'disabled': {
            type: Boolean,
            default: false
        },
        'tooltipText': {
            type: String,
            default: ""
        },
        'fileAttachEnabled': {
            type: Boolean,
            default: false
        },
        'fileAttachLimitMb': {
            type: Number,
            default: 2
        },
        'multiple': {
            type: Boolean,
            default: false
        },
        'step': {
            type: Number,
            default: 1
        },
        'stepper': {
          type: Boolean,
          default: false
        },
        'toggleStyle': {
          type: Boolean,
          default: false
        },
        'leadingIcon': {
          type: String,
          default: ""
        },
        'hideContent': {
          type: Boolean,
          default: false
        },
        'decimal': {
          type: Boolean,
          default: false
        },
        'digitsOnly': {
          type: Boolean,
          default: false
        },
        'attachedFile': {
          type: null,
          default: null
        }
    },
    data() {
        return {
            attachedFilePreview: null,
            attachedFileName: null,
            attachedFileIsVideo: false,
            contentVisible: false,
        }
    },
    computed: {
        effectiveType() {
            if (this.hideContent) {
                return this.contentVisible ? 'text' : 'password';
            }
            if (this.decimal) {
                return 'text';
            }
            return this.type;
        },
        effectiveInputMode() {
            if (this.decimal) {
                return 'decimal';
            }
            if (this.digitsOnly) {
                return 'numeric';
            }
            return this.$attrs.inputmode ?? null;
        },
        fileAccept() {
            if (this.onlyPng) return 'image/png';
            return this.accept || 'image/*';
        },
        attachedFileIcon() {
            return this.attachedFileIsVideo ? 'film.svg' : 'check.svg';
        },
        showLeadingIcon() {
            return !!this.leadingIcon && !this.attachedFilePreview && !this.attachedFileName;
        },
        inputPlaceholder() {
            if (this.attachedFileName) {
                return this.$t('generic.fileAttached', { name: this.attachedFileName });
            }
            return this.placeholder ? this.placeholder : '';
        }
    },
    watch: {
        customValue(newValue) {
          if (newValue && typeof newValue === 'string') {
            if (this.isValidImageUrl(newValue)) {
              this.attachedFilePreview = newValue;
            } else {
              this.attachedFilePreview = null;
            }
          }
        }
    },
    methods: {
        rootAttrs() {
            return { class: this.$attrs.class, style: this.$attrs.style };
        },
        inputAttrs() {
            return Object.fromEntries(
                Object.entries(this.$attrs).filter(([key]) => !['class', 'style', 'inputmode'].includes(key))
            );
        },
        onInput(event) {
            if (this.decimal) {
                this.$emit('update:customValue', applyDecimalInput(event));
                return;
            }
            if (this.digitsOnly) {
                this.$emit('update:customValue', applyIntegerInput(event));
                return;
            }
            this.$emit('update:customValue', event.target.value);
        },
        stepBy(direction) {
            if (this.disabled) {
                return;
            }
            const current = parseFloat(this.customValue);
            const base = isNaN(current) ? 0 : current;
            const next = Math.max(0, base + direction * this.step);
            const decimals = (String(this.step).split('.')[1] || '').length;
            this.$emit('update:customValue', String(parseFloat(next.toFixed(decimals))));
        },
        isValidImageUrl(url) {
          return /^https?:\/\/.+\.(jpg|jpeg|png|gif|webp|svg|asd)$/.test(url);
        },
        onAttachFileClicked() {
            this.$refs.fileInput.click();
        },
        onFilePicked(event) {
            // Get the list of selected files
            const files = event.target.files;
            if (!files || files.length === 0) {
                this.attachedFilePreview = null;
                this.attachedFileName = null;
                this.attachedFileIsVideo = false;
                this.$emit('update:attachedFile', null);
                return;
            }

            // Array to store file previews and validated files
            const filePreviews = [];
            const validFiles = [];

            for (const file of files) {
                // Check file size
                if (file.size > this.fileAttachLimitMb * 1024 * 1024) {
                    toast.error(this.$t('generic.fileSizeError', { size: this.fileAttachLimitMb }));
                    return; // Skip this file if it exceeds the size limit
                }

                const reader = new FileReader();
                reader.onload = (e) => {
                    filePreviews.push(e.target.result);
                };
                reader.readAsDataURL(file);

                // Add the file to the valid files array
                validFiles.push(file);
            }

            // Wait for all previews to be generated
            Promise.all(
                Array.from(files).map(
                    (file) =>
                        new Promise((resolve) => {
                            const reader = new FileReader();
                            reader.onload = () => resolve(reader.result);
                            reader.readAsDataURL(file);
                        })
                )
            ).then((previews) => {
                if (previews.length === 1) {
                    // Only images can be previewed with an <img> tag (e.g. not videos):
                    // for other files show a chip + the file name so the user sees it's attached
                    const isImage = validFiles[0].type.startsWith('image/');
                    this.attachedFilePreview = isImage ? previews[0] : null;
                    this.attachedFileName = isImage ? null : validFiles[0].name;
                    this.attachedFileIsVideo = validFiles[0].type.startsWith('video/');
                    this.$emit('update:attachedFile', validFiles[0]);
                } else {
                    // Otherwise, set and emit the arrays
                    this.attachedFilePreview = previews;
                    this.attachedFileName = null;
                    this.attachedFileIsVideo = false;
                    this.$emit('update:attachedFile', validFiles);
                }
            });
        }
    },
}
</script>

<style lang="scss" scoped>
.input-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    .hint-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 8px 8px !important;

        .input-hint {
            padding: 0 !important;
            font-size: 12px;
            font-weight: normal;
            color: $color-secondary-text;
            opacity: 0.8;
            margin: 0 !important;
        }

        .icon-info {
            stroke: rgba($color-secondary-text, 0.5);
            width: 12px;
            height: 12px;
        }

        .tooltip-container {
            line-height: 0 !important;
        }
    }



    .image-count-overlay {
        position: absolute;
        top: 0;
        width: 50px;
        height: 50px;
        border-radius: $radius-small;
        background-color: rgba(0, 0, 0, 0.2);
        color: white;
        padding: 4px 8px;
        font-size: 14px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
    }


    input {
        width: 100%;
        padding: 10px 40px 10px 20px;

        &.error {
            outline: 1px solid rgba($color-pastel-red, .3);;
            box-shadow: 0px 0px 15px rgba($color-pastel-red, .3);
        }

        &:disabled {
            opacity: 0.3;
        }
    }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}


input:not([type="datetime-local"]) {
  height: 44px;
}

@media (max-width: 768px) {
  input[type="datetime-local"] {
    height: 23px;
    &::-webkit-date-and-time-value {
      text-align: left;
    }
  }
}

input[type="datetime-local"]::-webkit-calendar-picker-indicator {
  position: absolute;
  right: 15px;
  width: 15px;
  height: 15px;
  color: white !important;
  fill: white !important;
  stroke: white !important;
  filter: invert(1) brightness(100%);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover{
    transform: scale(1.2);
  }
}

@media (max-width: 768px) {

  input[type="datetime-local"]::-webkit-calendar-picker-indicator {
    transition: none !important;
    &:hover{
      transform: none !important;
    }
  }
}



.switch-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 18px;
  border-radius: 16px;
  background: rgba($color-primary-blue, 0.08);
  text-align: left;
  transition: border-color 0.2s ease, background 0.2s ease, opacity 0.2s ease;
  cursor: pointer;

  &:hover {
    transform: none !important;
    border-color: rgba($color-primary-blue, 0.35);
  }

  &.checked {
    background: rgba($color-primary-blue, 0.08);
    border-color: rgba($color-primary-blue, 0.3);
  }

  &.disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
}

div.switch-row {
  cursor: default;
}

.text-content {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.title {
  margin: 0;
  color: $color-white-text;
  font-size: 14px;
  font-weight: 550;
}

.description {
  margin: 0;
  color: $color-secondary-text;
  font-size: 12px;
  line-height: 1.45;
  overflow: hidden;
  max-width: 100%;
}

.switch {
  position: relative;
  flex: 0 0 auto;
  width: 47px;
  height: 25px;
  border-radius: 999px;
  background: $color-secondary-text ;
  transition: background 0.24s ease;
}



.switch.checked {
  background: $color-primary-blue;
}

.thumb {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 17px;
  height: 17px;
  border-radius: 50%;
  background: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.22);
  transition: transform 0.24s ease;
}

.switch.checked .thumb {
  transform: translateX(22px);
}

.stepper-group {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  column-gap: $default-edge-spacing;

  .number-input {
    width: 48px;
    min-width: 48px;
    padding: 0 $default-edge-spacing-s !important;
  }

  .stepper-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 37px;
    min-width: 37px;
    height: 37px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: $color-input-back;
    cursor: pointer;

    svg {
      width: 13px;
      height: 13px;
      stroke: $color-secondary-text;
    }

    &:hover {
      background: rgba($color-primary-blue, 0.3);

      svg {
        stroke: $color-white-text;
      }
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
      background: $color-input-back;
    }
  }
}

.number-input {
  width: 72px;
  min-width: 72px;
  border: 1px solid rgba($color-primary-blue, 0.1);
  border-radius: 10px;
  background: rgba(129, 137, 201, 0.18);
  color: $color-white-text;
  font-size: 14px;
  text-align: center;
  outline: none;
  height: 37px !important;
  padding: 0 15px !important;

  &:focus {
    border-color: rgba($color-primary-blue, 0.5);
  }

  &:disabled {
    cursor: not-allowed;
  }
}

.switch-input{
  flex-direction: column !important;
  align-items: start !important;
  justify-content: space-between !important;
  gap: 10px !important;
  .text-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    .tooltip-container {
      .icon-info {
        margin-top: -2px;
        stroke: rgba($color-secondary-text, 0.5);
        width: 12px;
        height: 12px;
      }
    }
  }
  input {
    height: 37px !important;
    padding: 0 15px !important;
    padding-right: 40px !important;
    width: 100%;
  }
  .input-field-container {
    width: 100%;
    .image-attach-preview {
      width: 37px;
      height: 37px;
      margin-right: 10px;
      border-radius: $radius-small;
    }
    .file-attach-preview {
      width: 37px;
      height: 37px;

      svg {
        width: 16px;
        height: 16px;
      }
    }
  }

}

.input-field-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;

  .image-attach-preview {
    flex: 0 0 auto;
    width: $control-height;
    height: $control-height;
    margin-right: 10px;
    border-radius: $radius-small;
    object-fit: cover;
  }

  .file-attach-preview {
    flex: 0 0 auto;
    width: $control-height;
    height: $control-height;
    margin-right: 10px;
    border-radius: $radius-small;
    background: rgba($color-primary-blue, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 20px;
      height: 20px;
      stroke: $color-white-text;
    }
  }

  .trailing-icon {
    color: $color-secondary-text !important;
    position: absolute;
    right: $default-edge-spacing-l;
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  .leading-icon {
      :deep(.st0),
      :deep(.st1) {
          stroke: currentColor;
      }

    color: $color-secondary-text;
    stroke: currentColor;
    position: absolute;
    left: $default-edge-spacing-l;
    top: 50%;
    transform: translateY(-50%);
    width: 16px;
    height: 16px;
    pointer-events: none;
  }

  input.has-leading-icon {
    padding-left: 42px !important;
  }
}
</style>